import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于8848影院的常见疑问，这里都能找到答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6 hover:border-primary-500/30 transition-colors duration-200"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500/15 flex items-center justify-center mt-0.5">
                  <span className="text-xs font-bold text-primary-500">Q</span>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}